import * as beforeEnter from "./before-enter";
import ProgressLoader from "@Shared/@Utils/progress-loader";
export const runGuards = (...guardFunctions) => async (to, from, next) => {
  for (const guard of guardFunctions) {
    const result = await guard(to, from, next);
    if (!result) {
      ProgressLoader.done();
      ProgressLoader.remove();
      return;
    }
  }
  next();
};
export const authGuards = runGuards(beforeEnter.verifySession, beforeEnter.checkForRedirects);